export const QUARTERS = ["Q1", "Q2", "Q3", "Q4"];

export const MONTHS = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];

export const formatMonth = (month) =>
  new Date(2000, month - 1).toLocaleString("en", { month: "short" });

export const formatReportingYearPeriod = (reportingYear) => {
  if (!reportingYear) return "";

  return `${reportingYear.startYear} (${MONTHS[reportingYear.startMonth - 1]} ${
    reportingYear.startYear
  } - ${MONTHS[reportingYear.endMonth - 1]} ${reportingYear.endYear} )`;
};
